/**
 *
 * @param {Object} obj
 * @param {string[]} keySearchArr
 * @returns Object filtered
 */
export function filterObjectByKeys(obj, keySearchArr) {
  const filteredObj = {};
  for (const key of Object.keys(obj)) {
    if (keySearchArr.includes(key)) {
      filteredObj[key] = obj[key];
    }
  }
  return filteredObj;
}

export function removeUndefinedFieldsFromObj(obj) {
  return Object.fromEntries(
    Object.entries(obj).filter(([key, value]) => value !== undefined)
  );
}
